import { useEffect, useRef } from 'react';
export function useLatest(value) {
    const latestValue = useRef(value);
    useEffect(() => {
        latestValue.current = value;
    }, [value]);
    return latestValue;
}
